module.exports = __webpack_public_path__ + "static/media/3.71223f9f.jpg";